import { useDispatch, useSelector } from 'react-redux';
import { Box, Icon, Text, Wrapped } from '@quintoandar-tokko/jopijs';
import { useEffect, useRef, useState } from 'react';
import styles from '../filterBar.module.scss';
import { removeTag } from '@/store/slices/components/filterBar/FilterBarSlice';
import translations from '../FilterBar.trans.json';
import Trans from '@/components/shared/Trans';

function SelectionTags({ showClearFilters = true, items }) {
  const dispatch = useDispatch();

  const { selectedIds: allSelectedIds } = useSelector(
    (state) => state.FilterBarSlice.filters
  );
  const selectedIds = items ?? allSelectedIds;
  const containerRef = useRef();
  const [widthRestItemsWindow, setWidthRestItemsWindow] = useState(0);

  const tagsModalColor = (() => {
    const colorByPathMap = [
      { path: '/home', color: 'var(--grey-100)' },
      { path: '/leads', color: 'white' },
    ];

    const defaultColor = 'white';

    // eslint-disable-next-line
    for (const entry of colorByPathMap) {
      if (window.location.pathname.includes(entry.path)) {
        return entry.color;
      }
    }

    return defaultColor;
  })();

  if (selectedIds.length === 0) return null;

  const chips = selectedIds.map((item) => ({
    ...item,
    chipId: `${item.filter_type}-${item.id}`,
  }));

  const handleRemoveTag = (item) => {
    if (item?.dontRemove) return;
    dispatch(removeTag(item));
  };

  useEffect(() => {
    if (!containerRef.current) return () => {};

    const updateWidth = (nextWidth) => {
      setWidthRestItemsWindow(Math.max(0, Math.round(nextWidth || 0)));
    };

    const handleTransitionEnd = () => {
      if (!containerRef.current) return;
      const { width } = containerRef.current.getBoundingClientRect();
      updateWidth(width);
    };

    handleTransitionEnd();

    let resizeTimer;
    const resizeObserver = new ResizeObserver((entries) => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const { width } = entries[0].contentRect;
        updateWidth(width);
      }, 10);
    });

    resizeObserver.observe(containerRef.current);
    window.addEventListener('resize', handleTransitionEnd);

    return () => {
      window.removeEventListener('resize', handleTransitionEnd);
      resizeObserver?.disconnect();
    };
  }, []);

  return (
    <Box
      ref={containerRef}
      className={styles.selectionTagsContainer}
      style={{ '--tags-modal-color': tagsModalColor }}
    >
      <Text variant="body.fontSize14" className={styles.filterText}>
        {Trans(translations, 'FilteringBy')}:
      </Text>

      <Wrapped
        key={widthRestItemsWindow + chips.map((item) => item.chipId).join()}
        items={chips}
        printKey="text"
        idKey="chipId"
        tagVariant="secondary"
        fnClose={handleRemoveTag}
        widthRestItemsWindow={widthRestItemsWindow}
        style={{
          flexGrow: '1',
          width: `${widthRestItemsWindow - 100}px`,
        }}
        showCloseIconCallback={(item) => !item.dontRemove}
      />

      {showClearFilters && (
        <Box
          className={styles.clearFiltersContainer}
          onClick={() => dispatch(removeTag())}
        >
          <Icon icon="icon-eliminar" fontSize="16px" />
          <Text variant="body.fontSize12">
            {Trans(translations, 'ClearFilters')}
          </Text>
        </Box>
      )}
    </Box>
  );
}

export default SelectionTags;
